import React, { useState, useCallback, useEffect } from 'react';
import { orgTypes } from '../../Constants';
import useApi from '../../api/useApi';

function ProjectUser({ handleClose, notification, action, selectedUser, refreshList }) {
  const { userId } = JSON.parse(localStorage.user).user;
  const orgId = JSON.parse(localStorage.user).organization.id;
  const assignUser = [{
    userId: selectedUser.id,
    role: selectedUser.role,
  }];

  const formModel = {
    users: assignUser,
    createdBy: userId,
  };

  const [formData, setFormData] = useState([]);
  const [searchData, setSearchData] = useState({ q: '' });
  // const [{ isLoading, isError, data }, postData] = useApi();
  const [{ isLoading, isError, data }, getProject] = useApi();
  const [state2, setAssignProject] = useApi();
  const [filteredData, setFilteredData] = useState([]);
  const [selectedProject, setSelectedProject] = useState();
  // const [state2, updateData] = useApi();
  const handleInputChange = useCallback((e) => setSearchData({ ...searchData, [e.target.name]: e.target.value }));
  useEffect(() => {
    getProject(`/organization/${orgId}/projects`, 'GET');
  }, [action]);

  // create response
  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData(data.projects);
      setFilteredData(data.projects);
      // refreshList();
    }
    if (isError) {
      notification('error', 'Unable to fetch project detail');
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (formData.length <= 0) {
      return;
    }

    if (searchData.q === '') {
      setFilteredData(formData);
    }
    // if (formData.asset_type === '' && formData.device_type === '' && formData.project_name === '') {
    // }
    let z = formData;

    if (searchData.q) {
      z = z.filter((x) => {
        const normalizedQuery = searchData.q.toLowerCase();
        return x?.projectName?.toLowerCase().indexOf(normalizedQuery) >= 0;
      });
    }

    if (z.length > 0) setFilteredData(z);
    else setFilteredData([]);
  }, [searchData]);

  // getOrganization for update response
  // useEffect(() => {
  //   if (!state.isLoading && !state.isError && state.data) {
  //     setFormData(state.data.message);
  //   }
  // }, [state]);

  // update response

  const projects = () => {
    setAssignProject(`/project/${selectedProject}/users`, 'POST', formModel);
  };
  useEffect(() => {
    if (!state2.isLoading && !state2.isError && state2.data) {
      notification('success', 'Assigned user to project successfully');
      refreshList();
      handleClose();
    }
    if (state2.isError) {
      notification('error', 'Unable to assigned user to project ');
      handleClose();
    }
  }, [state2]);
  return (
    <div
      className="flex justify-center items-center h-full w-full z-20 fixed"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))', overflowY: 'scroll' }}
    >
      <div className="bg-white w-1/4 h-2/3 px-5 pt-4 relative rounded-2xl">
        <img
          src="assets/img/Close.svg"
          className="absolute top-3 right-3 h-3 cursor-pointer"
          alt=""
          onClick={handleClose}
        />

        <p className="font-bold text-sm text-textBlue1">Select Project</p>
        <div
          className="mt-2 text-xs p-3 flex justify-between items-center"
          style={{
            border: '0.75px solid #B3B3B3',
            borderRadius: '4px',
          }}
        >
          <input
            type="text"
            placeholder="Start typing project name..."
            autoComplete="off"
            className="text-textBox bg-transparent focus:outline-none"
            value={searchData.q}
            name="q"
            onChange={handleInputChange}
            // style={{ borderColor: '#e6e6e6' }}
          />
          <img src="assets/img/Search.png" className="h-3 ml-2 " alt="" />
        </div>
        <div
          className="m-auto mb-4 h-2/3 w-full flex rounded-md border-white"
          style={{ boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)', borderRadius: '3px', color: '#9B9B9B' }}
        >
          <div className="pb-1 showScroll h-64 " style={{ overflow: 'auto', width: '98%', marginTop: '10px' }}>
            <ul>
              {filteredData.map((value, index) => {
                return (
                  <li className="flex items-center text-sm p-2 focus:outline-none cursor-pointer">
                    <input type="checkbox" id={value.id} className="mr-2" style={{ borderColor: '#9B9B9B' }} 
                    checked={selectedProject === value.id}
                    onClick={(e) => {
                      setSelectedProject(e.target.id);
                    }}/>
                    {value.projectName}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="absolute right-3">
          {state2.isLoading || isLoading ? (
            <img src="assets/img/loader.svg" className="absolute w-16 right-28 mx-auto" alt="" />
          ) : (
            <div className="flex text-xs">
              <button
                type="submit"
                onClick={() => handleClose()}
                className="rounded-3xl border focus:outline-none px-5 py-2 mr-3 cursor-pointer "
                // style={{ border: '1px solid #16406D' }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="rounded-3xl focus:outline-none px-8 py-2 text-white bg-btnBg cursor-pointer "
                style={{ border: '1px solid #16406D' }}
                onClick={projects}
              >
                Confirm
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProjectUser;
